"use client"

import { Card, CardContent, CardHeader, CardTitle } from "../ui/card"

interface PlaceholderPageProps {
  title: string
  icon: React.ReactNode
}

export function PlaceholderPage({ title, icon }: PlaceholderPageProps) {
  return (
    <div className="p-4 sm:p-6 space-y-6">
      <Card>
        <CardHeader className="border-b">
          <CardTitle className="text-2xl font-semibold text-gray-900 flex items-center gap-2">
            {icon}
            {title}
          </CardTitle>
        </CardHeader>

        <CardContent className="p-0"> 

      <iframe
        title="TMS Live Data Dashboard"
        src="https://app.powerbi.com/reportEmbed?reportId=5a34b822-1cc5-411e-94b1-658cf4544a66&autoAuth=true&ctid=73136b73-224c-40dc-8a8d-03e6ab8917d8"
        className="w-full h-[800px] border-0"
        allowFullScreen
      ></iframe>
        </CardContent>
      </Card>
    </div>
  )
}
